import { useState, useEffect, useMemo } from 'react';
import { useLabels } from 'wsm-common-data';

const useAriaLive = (
	isSearchTermLongEnough,
	hasResultsLocal,
	hasEmptyResultsLocal
) => {
	const [announceText, setAnnounceText] = useState('');
	const labels = useLabels();

	const noResults = useMemo(
		() => labels.get('NO_SEARCH_RESULTS_FOUND'),
		[labels]
	);
	const resultsReady = useMemo(
		() => labels.get('SEARCH_RESULTS_READY'),
		[labels]
	);

	useEffect(() => {
		const timer = setTimeout(() => {
			if (isSearchTermLongEnough && hasResultsLocal) {
				setAnnounceText(resultsReady);
			} else if (isSearchTermLongEnough && hasEmptyResultsLocal) {
				setAnnounceText(noResults);
			} else {
				setAnnounceText('');
			}
		}, 30);

		return () => clearTimeout(timer);
	}, [
		isSearchTermLongEnough,
		hasResultsLocal,
		hasEmptyResultsLocal,
		noResults,
		resultsReady
	]);

	return announceText;
};

export default useAriaLive;
